<template>
  <div>
    <div class="details-row">
        <label>{{ label }}</label>
        <div class="details-spacer" v-if="description"></div>
        <v-tooltip top v-if="description">
          <template v-slot:activator="{ on }">
            <v-icon small v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ description }}</span>
        </v-tooltip>
      </div>
      <div class="slot-wrapper">
        <slot></slot>
      </div>
  </div>
</template>
<script>
export default {
  name: 'ActionFieldContainer',
  props: {
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="sass" scoped>
.details-row
  display: flex
  flex-direction: row

.slot-wrapper > *
  margin-top: 0px
  padding-top: 0px

.details-spacer
  width: 8px
</style>
